/* ============================================================
   OSMANLI DOĞAL TAŞ — Enneagram ölçeği  (v2, 2026-09-21)

   ▸ NEDEN YENİLENDİ — 497 gerçek kullanıcıda ölçüldü:
     Tip 8 %21,7 · Tip 5 %14,3 çıkarken **Tip 9 yalnız %0,8 (497 kişide 4)**,
     Tip 6 %7,6, Tip 7 %5,2. Literatürde 9 ve 6 en yaygın tiplerdendir.
     Sebep puanlama matematiği değil (o doğru), MADDE KOLAYLIĞI farkıydı:
     tiplerin ortalama z'leri 5:+0,49 8:+0,43 … 7:−0,39 9:−0,74 — arada 1,22 z.
     Yani 8/5'in maddeleri "herkesin katılacağı" cümlelerdi (ör. "sevdiklerimi
     korumak için çatışmayı göze alırım"), 9/7'ninkiler ise kişinin bir kusuru
     kabul etmesini istiyordu (ör. "rahatım bozulmasın diye önemli konuları
     ertelerim"). İpsatif z-skor KİŞİ eğilimini düzeltir, MADDE kolaylığını değil.

   ▸ v2 DENGE KURALI — her tipin 5 maddesi aynı bandı kapsar:
       2 madde  ONAYLAYICI  (tipin erdemi; söylemesi kolay)
       2 madde  NÖTR-AYIRT EDİCİ (motivasyon; yalnız o tip "tam olarak" der)
       1 madde  GÖLGE      (dürüst itiraf; söylemesi görece zor)
     Böylece hiçbir tip yalnız övgüden ya da yalnız itiraftan oluşmuyor.
     Her maddenin bandı `b` alanında yazılıdır: 'o' | 'n' | 'g'.

   ▸ MADDE YAZIM İLKESİ (v1'den korundu): tip DAVRANIŞ değil MOTİVASYON ile
     ayrılır. "Düzenliyimdir" 1'i de 3'ü de 6'yı da gösterir; "hata yaptığımda
     kendimi affedemem" yalnız 1'in iç sesidir.

   ▸ Maddeler tip sırasına göre DEĞİL karışık dizilidir.
   ============================================================ */
(function (g) {
  'use strict';

  /* t: ölçtüğü tip · b: denge bandı (o=onaylayıcı, n=nötr, g=gölge) · m: metin */
  var CEKIRDEK = [
    { t: 1, b: 'n', m: 'İçimde sürekli “doğrusu bu değil” diyen bir ses var.' },
    { t: 5, b: 'n', m: 'Bir konuyu enine boyuna anlamadan onun hakkında konuşmak bana ağır gelir.' },
    { t: 2, b: 'o', m: 'İnsanların neye ihtiyacı olduğunu onlar söylemeden anlarım.' },
    { t: 8, b: 'n', m: 'Bir ortama girdiğimde gücün kimde olduğunu hemen sezerim.' },
    { t: 4, b: 'n', m: 'Kendimi çoğu insandan farklı hissederim.' },

    { t: 7, b: 'o', m: 'Aklıma gelen yeni fikirler beni heyecanlandırır; önümde hep güzel bir sonraki şey vardır.' },
    { t: 9, b: 'o', m: 'Uyum içinde olmak, haklı çıkmaktan benim için daha değerlidir.' },
    { t: 3, b: 'n', m: 'Bir işe girişmeden önce “bu beni nereye götürür” diye bakarım.' },
    { t: 6, b: 'o', m: 'Bir şeyler ters giderse diye önceden hazırlıklı olmak beni rahatlatır.' },
    { t: 1, b: 'g', m: 'Hata yaptığımda kendimi kolay affedemem.' },

    { t: 4, b: 'g', m: 'Bende eksik olan bir şey var gibi gelir; başkalarında o var sanırım.' },
    { t: 2, b: 'n', m: 'Birinin yükünü hafifletmek, kendi işimi yapmaktan daha çok içimi ısıtır.' },
    { t: 5, b: 'o', m: 'Karmaşık bir şeyi tek başıma çözüp anlamak bana derin bir tatmin verir.' },
    { t: 8, b: 'o', m: 'Kimse söylemeden sorumluluğu üstlenirim; dümensiz kalmaya tahammülüm yoktur.' },
    { t: 3, b: 'o', m: 'Başardığım işler kim olduğumun bir parçası; onlar olmadan kendimi anlatamam.' },

    { t: 9, b: 'n', m: 'İnsanlar arasındaki gerginliği herkesten önce hisseder, yatıştırmak isterim.' },
    { t: 6, b: 'n', m: 'Kararımı verdikten sonra bile doğru mu diye tekrar sorgularım.' },
    { t: 7, b: 'n', m: 'Planlarımın değişebilir olması beni rahatlatır; kapılar açık kalsın isterim.' },
    { t: 1, b: 'o', m: 'Bir işi doğru yapmak, hızlı yapmaktan benim için daha önemlidir.' },
    { t: 4, b: 'n', m: 'Duygularımın derinliği bazen beni de yorar.' },

    { t: 3, b: 'n', m: 'Başarısız görünmek, benim için başarısız olmaktan daha kötüdür.' },
    { t: 5, b: 'n', m: 'Duygularımı yaşadığım anda değil, sonradan tek başımayken fark ederim.' },
    { t: 2, b: 'g', m: 'Birine faydam dokunmadığında kendimi gereksiz hissederim.' },
    { t: 6, b: 'n', m: 'Otoriteye hem ihtiyaç duyarım hem de ondan şüphelenirim.' },
    { t: 8, b: 'g', m: 'Bana yön vermeye kalkan birine karşı içimde bir direnç oluşur.' },

    { t: 9, b: 'g', m: 'Rahatım bozulmasın diye önemli konuları ertelerim.' },
    { t: 7, b: 'o', m: 'Kötü bir durumda bile iyi tarafı hızla bulurum.' },
    { t: 1, b: 'n', m: 'Bir şeyin olması gereken hâli ile şu anki hâli arasındaki farkı hemen görürüm.' },
    { t: 4, b: 'o', m: 'Güzel ve anlamlı olana karşı ince bir duyarlılığım var.' },
    { t: 3, b: 'g', m: 'Gerçekte olduğumdan daha iyi görünmek için kendimi ayarladığım olur.' },

    { t: 5, b: 'g', m: 'İhtiyaçlarımı azaltarak kimseye bağımlı olmamayı tercih ederim.' },
    { t: 2, b: 'o', m: 'Sevdiklerim için yorulmak bana yük değil, iyi gelir.' },
    { t: 6, b: 'o', m: 'Güvenmek bana kolay gelmez; ama bir kez güvendiysem sonuna kadar arkasındayım.' },
    { t: 8, b: 'n', m: 'İnsanlar bana sert diyor ama ben sadece net konuşuyorum.' },
    { t: 9, b: 'o', m: 'Telaşlı ortamlarda bile içimde sakin kalan bir yer vardır.' },

    { t: 7, b: 'n', m: 'Bir şeye uzun süre bağlı kalmak, kaçırdıklarımı düşündürür bana.' },
    { t: 1, b: 'o', m: 'Söz verdiğim şeyi, kimse denetlemese bile eksiksiz yaparım.' },
    { t: 4, b: 'o', m: 'Gerçek ve derin olanı ararım; yüzeysel bir yakınlık beni doyurmaz.' },
    { t: 3, b: 'o', m: 'Hedef koyup ona ulaşmak bana enerji verir.' },
    { t: 5, b: 'o', m: 'Kendi alanım ve sessizliğim olduğunda en berrak düşünen hâlime kavuşurum.' },

    { t: 6, b: 'g', m: 'Her şey yolundayken bile içimde bir tedirginlik olur.' },
    { t: 2, b: 'n', m: 'Birinin beni sevmesi için önce ona lazım olmam gerektiğini hissederim.' },
    { t: 8, b: 'o', m: 'Haklı olduğuma inandığımda, kimsenin hoşuna gitmese de söylerim.' },
    { t: 7, b: 'g', m: 'Acı veren duygularda uzun kalmam; aklımı hemen başka yere çeviririm.' },
    { t: 9, b: 'n', m: 'Zorlamadan, kendi akışında giden bir hayat bana en çok yakışanıdır.' }
  ];

  /* i: içgüdü — sp (kendini koruma) · so (sosyal) · sx (birebir) */
  var ICGUDU = [
    { i: 'sp', m: 'Maddi düzenim ve sağlığım yerinde olmadan hiçbir şeye odaklanamam.' },
    { i: 'so', m: 'Bir gruba ait olmak benim için hayati önem taşır.' },
    { i: 'sx', m: 'Yüzeysel kalabalık yerine tek bir kişiyle derin bağ kurmayı isterim.' },
    { i: 'sp', m: 'Evimin ve rutinimin bozulması beni derinden rahatsız eder.' },
    { i: 'so', m: 'Bir ortamda kimin nerede durduğunu, dengeleri hemen okurum.' },
    { i: 'sx', m: 'Beni çeken bir insan ya da konu olduğunda gerisini unuturum.' },
    { i: 'sp', m: 'Zor bir gün için elimde birikim olsun isterim; bu beni rahatlatır.' },
    { i: 'so', m: 'İnsanlar arasında nasıl algılandığım üzerinde çok düşünürüm.' },
    { i: 'sx', m: 'İlişkilerde yoğunluk ve tutku yoksa çabuk sıkılırım.' }
  ];

  /* Gelişim bandı. ters:true olan madde ters kodlanır (6 - cevap). */
  var DURUM = [
    { m: 'Son zamanlarda kendimi kendim gibi hissediyorum; dengedeyim.', ters: false },
    { m: 'Zorluk karşısında eskisine göre daha çabuk toparlanıyorum.', ters: false },
    { m: 'Kendimi tekrar eden kalıplara sıkışmış hissediyorum.', ters: true }
  ];

  var LIKERT = [
    { v: 1, k: 'Hiç değil' },
    { v: 2, k: 'Pek değil' },
    { v: 3, k: 'Kısmen' },
    { v: 4, k: 'Çoğunlukla' },
    { v: 5, k: 'Tam olarak' }
  ];

  function sayfalar(adet) {
    adet = adet || 5;
    var hepsi = [];
    CEKIRDEK.forEach(function (x, i) { hepsi.push({ id: 'c' + i, tur: 'tip', t: x.t, m: x.m }); });
    ICGUDU.forEach(function (x, i) { hepsi.push({ id: 'i' + i, tur: 'icgudu', i: x.i, m: x.m }); });
    DURUM.forEach(function (x, i) { hepsi.push({ id: 'd' + i, tur: 'durum', ters: x.ters, m: x.m }); });

    var sy = [];
    for (var k = 0; k < hepsi.length; k += adet) sy.push(hepsi.slice(k, k + adet));
    return sy;
  }

  function puanla(cevap) {
    var ham = {}, i;
    for (i = 1; i <= 9; i++) ham[i] = 0;
    var ham3 = { sp: 0, so: 0, sx: 0 };
    var durumToplam = 0, durumAdet = 0;

    CEKIRDEK.forEach(function (x, k) {
      var v = cevap['c' + k];
      if (v) ham[x.t] += v;
    });
    ICGUDU.forEach(function (x, k) {
      var v = cevap['i' + k];
      if (v) ham3[x.i] += v;
    });
    DURUM.forEach(function (x, k) {
      var v = cevap['d' + k];
      if (v) { durumToplam += x.ters ? (6 - v) : v; durumAdet++; }
    });

    var saglik = durumAdet ? (durumToplam - durumAdet) / (durumAdet * 4) : null;
    /* madde düzeyinde cevaplar: ileride madde kolaylığını VERİDEN ölçebilmek için
       (v1'de saklanmadığı için ofsetler ancak dolaylı hesaplanabilmişti) */
    var maddeler = CEKIRDEK.map(function (x, k) { return cevap['c' + k] || 0; });
    return { ham: ham, ham3: ham3, saglik: saglik, maddeler: maddeler };
  }

  function toplamMadde() { return CEKIRDEK.length + ICGUDU.length + DURUM.length; }

  g.ODTEnneagramOlcek = {
    CEKIRDEK: CEKIRDEK, ICGUDU: ICGUDU, DURUM: DURUM, LIKERT: LIKERT,
    sayfalar: sayfalar, puanla: puanla, toplamMadde: toplamMadde, surum: 2
  };
})(typeof window !== 'undefined' ? window : globalThis);
